import { useState } from 'react';
import * as Sentry from '@sentry/react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertTriangle, Bug, Zap } from 'lucide-react';

// Component that throws on render
function BuggyComponent() {
  throw new Error('Test render error from BuggyComponent');
  return null;
}

export default function SentryTest() {
  const [showBuggy, setShowBuggy] = useState(false);

  const triggerError = () => {
    throw new Error('Test error triggered by button click');
  };

  const triggerAsyncError = async () => {
    await new Promise((_, reject) =>
      setTimeout(() => reject(new Error('Test async rejection')), 100)
    );
  };

  const captureMessage = () => {
    Sentry.captureMessage('Test message from SentryTest page', 'info');
    alert('Message sent to Sentry!');
  };

  return (
    <div className="min-h-screen bg-background p-8">
      <Card className="max-w-md mx-auto">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Bug className="h-5 w-5" />
            Sentry Test Page
          </CardTitle>
          <CardDescription>
            Trigger test errors to verify Sentry integration
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button onClick={captureMessage} className="w-full" variant="outline">
            <Zap className="mr-2 h-4 w-4" />
            Send Test Message
          </Button>

          <Button onClick={triggerError} className="w-full" variant="destructive">
            <AlertTriangle className="mr-2 h-4 w-4" />
            Trigger Click Error
          </Button>

          <Button onClick={triggerAsyncError} className="w-full" variant="destructive">
            <AlertTriangle className="mr-2 h-4 w-4" />
            Trigger Async Error
          </Button>

          <Button onClick={() => setShowBuggy(true)} className="w-full" variant="destructive">
            <AlertTriangle className="mr-2 h-4 w-4" />
            Trigger Render Error
          </Button>

          {showBuggy && <BuggyComponent />}

          <p className="text-xs text-muted-foreground text-center pt-4">
            Dashboard: <a href="https://okostec.sentry.io" target="_blank" rel="noopener" className="underline">okostec.sentry.io</a>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
